import { render, staticRenderFns } from "./ChangeInEmissions.vue?vue&type=template&id=20710630&"
import script from "./ChangeInEmissions.vue?vue&type=script&lang=js&"
export * from "./ChangeInEmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports